export const MAX_RECENT_STOP_IDS = 15;
